<template>
<div class="sezione"  style="padding:0 8px;" >


<div class="yo-fixed-top" style="top:132px;z-index:999;">
<div class="row el-container" style="background:#fff;padding:16px 20px;">
   <div class="col s12">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="line-height: 36px;">
         <el-breadcrumb-item><span class="yo-text-bold yo-text-m">Funnel Plot</span></el-breadcrumb-item>
         <el-breadcrumb-item><span class="yo-text-m">Anno 2021</span></el-breadcrumb-item> 
         
      </el-breadcrumb>
   </div>
</div>
</div>

<div style="margin:40px 0;">
La proporzione dell’indicatore riferita all’intero Network viene rappresentata dalla linea continua orizzontale,
 mentre le linee tratteggiate,
 che formano un imbuto,
 indicano rispettivamente gli intervalli di confidenza al 95% (limite superiore ed inferiore con linea tratteggiata di colore nero) e 99% (limite superiore ed inferiore con linea tratteggiata di colore rosso).
  L’intervallo di confidenza è l’intervallo di valori entro i quali si stima che cada,
 con un livello di probabilità del 95% o del 99%,
 il valore dell’indicatore osservato nell’intero Network.
  L’ampiezza degli intervalli di confidenza si restringe all’aumentare del volume dei neonati assistiti (asse orizzontale).
  Ciascun pallino azzurro rappresenta un centro: la posizione del pallino nel grafico è determinata dal valore dell’indicatore sull’asse verticale e dal volume dei neonati assistiti (sull’asse orizzontale).
  <strong>In colore rosso è evidenziato il vostro centro.</strong>
<br /><br />
Essere sopra o sotto la banda dell’intervallo di confidenza sta ad indicare una condizione di “outlier”,
 ossia per quell’indicatore il centro ha una performance peggiore (collocato sopra il limite superiore dell’intervallo di confidenza) o migliore (se collocato sotto limite inferiore dell’intervallo di confidenza) rispetto all’insieme dei centri dell’intero Network.
  Si ricorda che questa rappresentazione è basata sul valore grezzo dell’indicatore che non tiene conto di potenziali fattori di confondimento che potrebbero modificare la singola posizione dei centri all’interno del grafico.
</div>



</div>
</template>

<script>

export default {
components: {
   
},
data() {
   return {
   }
},
created () {
},
methods: {
   
},

computed:{
}
}
</script>


<style >

</style>
